import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import type { SortingItem, SortOptions } from '@/shared/types';
import { SortTypes } from '@/shared/types';
import { getColumnSorting, SortButton, useHeaderHovered } from '@/shared/ui';
import { selectConfig, updateSorting } from '../../model/slice';

interface Props {
  cohortAge: string;
}

export function CohortAgeHeader({ cohortAge }: Props) {
  const dispatch = useAppDispatch();
  const { sorting } = useAppSelector(selectConfig)!;
  const sortingItem = getColumnSorting(sorting, cohortAge);
  const hovered = useHeaderHovered(cohortAge);

  const handleSimpleSortingUpdate =
    (name: string) => (newSortOption?: SortOptions) => {
      const sortingItem: SortingItem | undefined = newSortOption
        ? {
            type: SortTypes.SIMPLE,
            name,
            value: newSortOption,
          }
        : undefined;

      dispatch(
        updateSorting({
          column: name,
          item: sortingItem,
        }),
      );
    };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontWeight: 500,
        }}
      >
        Day {cohortAge.slice(1)}
      </Box>
      {(hovered || !!sortingItem) && (
        <SortButton
          order={sortingItem?.index}
          value={sortingItem?.value}
          onChange={handleSimpleSortingUpdate(cohortAge)}
        />
      )}
    </Box>
  );
}
